export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00421.f397dc9a.png";